import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getLeadDetail, leadApproveReject, leadDocumentResubmit } from '@src/store/slices/lead';
import dateFormat from 'dateformat';
import * as HELPER from "@src/config/helper";
import ReactPanZoom from 'react-image-pan-zoom-rotate';
import ConfirmPopUp from '../common/ConfirmPopUp';
import { toast } from 'react-toastify';
import { Accordion } from 'react-bootstrap';
import { useLanguage } from "@src/context/LanguageContext";
import {LEAD_ADDON, SHOW_ACTION_STATUS, SHOW_ACTION_DOC_STATUS} from '@src/config/constant';
import { useDispatch,useSelector } from 'react-redux';
import { getMasterConfig } from '../store/slices/common';
import FullPageLoader from '@src/common/FullPageLoader';


type OptionType = {
  value: number;
  label: string;
};


const LeadDetail: React.FC = () => {
    let [loading, setLoading] = useState(false);
    const dispatch: any = useDispatch();
    const queryParams = useParams();
    const lead_id = queryParams.id;
    const {translations, language} = useLanguage();
    const [selectedReason, setSelectedReason] = useState<OptionType | null>(null);
    const [comment, setComment] = useState<string | null>(null);
    const [modalVisible, setModalVisible] = useState<string | null>(null);

    //const reasonList = location.state?.reasonList; 
    const [reasonList, setReasonList] = useState<any>([]);
    
    let [leadDetail, setLeadDetail] = useState<any |null>(null);
    let [sliderImages, setSilderImages] = useState<any>([]);
    let [activeImage, setActiveImage] = useState<any>(null);
    let [activeImageIndex, setActiveImageIndex] = useState<number>(-1);
    let [activeDocExtension, setActiveDocExtension] = useState<string>('')
    let [documentId, setDocumentId] = useState<number>(0);
    let [popoupError, setPopoupError] = useState<object>({});
    let [leadAddon, setLeadAddon] = useState<any |null>(null);

    const commonState = useSelector((state: any) => state?.common?.common);
    const leadStatusList = commonState?.lead_status || []; 
    let status_name = leadStatusList.find((item: any) => item.value === leadDetail?.action_status)?.label || '';  

    const ShowRejectModel = (type: string, doc_id: number = 0) => {
        setModalVisible(type);
        if(doc_id) setDocumentId(doc_id);
        
    };

    useEffect(() => {
        if(lead_id) getDetail(lead_id);
        // eslint-disable-next-line
    },[]);

    useEffect(() => {
        getMasterConfigApi();
        // eslint-disable-next-line
    }, [translations]);

      const getMasterConfigApi = () => {
        setLoading(true);
        dispatch(getMasterConfig()).then((res: any) => {
          if (res && res.status === 200) {
            setLoading(false);
            if (res.data) {
              if(res.data['reason_master']){
                setReasonList(res.data['reason_master']);
              }
            }
          }
        }).catch((err: Error) => {
          setLoading(false);
        })
      }

    const getDetail = (lead_id: string) => {
        const params: any = {lead_id};
        setLoading(true)
        getLeadDetail(params).then((res: any) => {
            setLoading(false)
            if (res && res.status === 200) {
                setLeadDetail({...res.data});
                setDocumentArray(res.data);
                if(res.data.lead_addon && res.data.lead_addon.length) {
                    setLeadAddonDetail(res.data.lead_addon);
                }
            }
        }).catch(err => setLoading(false))
    }

    const setLeadAddonDetail = (addons: any) => {
        if(addons && addons.length) {
            let addon_array: any = [];
            for(let addon of addons){
                let addon_name = addon.addon_lang_name.find((item: any) => item.lang_id === (language === 'en' ? 1 : 2)).name;
                addon_array.push({...addon, name: addon_name});
            }
            setLeadAddon(addon_array);
        }
    }

    const setDocumentArray = (lead: any) => {
        let imageArray = [];
        if (lead?.lead_document && lead?.lead_document.length > 0) {
            imageArray = lead?.lead_document.map((item: any) => {
                return {id: item.id, document_id: item.document_id,path: item.doc_path, name: item.document_name,  doc_status: item.status};
            });
        }
        let curActiveImgIndex = imageArray[activeImageIndex] ? activeImageIndex : 0
        let curActiveImage = imageArray[curActiveImgIndex]
        setActiveImage(curActiveImage)
        setActiveImageIndex(curActiveImgIndex)
        setSilderImages(imageArray)     
    };

    const handleReasonChange = (value: any, key: string) => {
         const updatedErrors: any = { ...popoupError };
        if(key === 'reason_id'){
            setSelectedReason(value);
            delete updatedErrors.reason_id;
        }else{
            setComment(value);
            delete updatedErrors.comment;
        }

        setPopoupError(updatedErrors);
    };

    const confirmYes = async () => {
        if(modalVisible === 're_submit' && documentId){           
            let updateObject = {
                lead_id: lead_id,
                comment: comment,
                doc_id: documentId
            };
            const updateErrors: any = {...popoupError}; 
            if(!comment || comment === null || comment === undefined) {
                updateErrors.comment = translations.commonMsg?.required;
                setPopoupError(updateErrors) 
                return
            } 
            setLoading(true)
            leadDocumentResubmit(updateObject).then((res: any) => {
                setLoading(false);
                if (res && res.status === 200) {
                    toast.success(res.message);
                    if(lead_id) getDetail(lead_id);
                    setLoading(false);
                }
            }).catch(err => setLoading(false))
        }else{
            if(modalVisible === 'reject'){
                let is_valid = true;
                const updateErrors: any = {...popoupError};
                if(!selectedReason || selectedReason === null || selectedReason === undefined) {
                    updateErrors.reason_id = translations.commonMsg?.required;
                    is_valid = false;
                }
                if(!comment || comment === null || comment === undefined) {
                    updateErrors.comment = translations.commonMsg?.required;
                    is_valid = false;
                }
                if(!is_valid) {
                    setPopoupError(updateErrors) 
                    return
                };
            }
            
            let updateObject = {
                id: lead_id,
                reason_id: selectedReason,
                comment: comment,
                type: modalVisible === 'reject' ? 'reject' : 'approve',
                status:  modalVisible === 'approve' ? 1 : 2
            };
            setLoading(true)
            leadApproveReject(updateObject).then((res: any) => {
                setLoading(false)
                if (res && res.status === 200) {
                    toast.success(res.message);
                    if(lead_id) getDetail(lead_id);
                    
                    setLoading(false);
                }
            }).catch(err => setLoading(false))
        }
       confirmNo();
    };

    const confirmNo = () => {
        setModalVisible(null);
        setComment(null);
        setSelectedReason(null);
    };

    const checkImageType = () => {
        if (activeImage && activeImage.path) {
            let activeImgfile = activeImage?.path?.toLowerCase()?.split('?')?.[0]
            let activeImgFileType = activeImgfile?.split('.')
            activeImgFileType = activeImgFileType?.[activeImgFileType?.length - 1]

            let fileType = 'image'

            if (activeImgFileType === 'pdf') fileType = 'pdf'
            if (['csv', 'xls', 'xlsx'].includes(activeImgFileType)) fileType = "excel"
            if (activeImgFileType === 'doc' || activeImgFileType === "docx") fileType = "word"

            setActiveDocExtension(fileType)
        }
        return
    }

    /**
     * handles image selection (prev && next)
     * @param type 
     */
    const handleImageChange = (type: string) => {

        if (type === 'next') {
            let updatedIndex = activeImageIndex === sliderImages.length - 1 
            ? 0 
            : activeImageIndex + 1;
            let newImage = sliderImages[updatedIndex]

            setActiveImage(newImage)
            setActiveImageIndex(updatedIndex)
        }

        if (type === 'previous') {
            let updatedIndex = activeImageIndex - 1
            let newImage = sliderImages[updatedIndex]

            setActiveImage(newImage)
            setActiveImageIndex(updatedIndex)
        }

        //resetImagePosition()
    }

    // const resetImagePosition = () => {
    //     let imgBox: any = document.querySelector('.active-img');
    //     if (imgBox) {
    //         imgBox.setAttribute('style', `width: ${418}px; height: ${284}px`)
    //     }
    // }

    useEffect(() => {
        if (activeImage && activeImage.path) {
            checkImageType()
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeImage])

    useEffect(() => {
         setLeadAddonDetail(leadDetail?.lead_addon);   
         // eslint-disable-next-line
    }, [translations])

    const getAddonValue = (item: any, type: number) => {
       if(leadDetail && leadAddon){
        const result = leadAddon.find((addon: any) => addon.addon_id === item.id);
        if (result) {
            let label = type === 1 ? result.name : (language === 'en') ? item.name : item.name_id;
            let value = type === 1 ? 'Yes' : type === 2 ? HELPER.addCurrencyFormatting(result.coverage_amount || 0): result.seat_capacity || '0';
            return {label, value};
        }else{
            return false
        }
       }
        return false;
    }

    const getAdditionalInfo = (leadDetail: any) => {
        const accessoriesInfo: any = [
            leadDetail?.accessories_count,
            leadDetail?.accessories_description,
           (+leadDetail?.accessories_price > 0) ? HELPER.addCurrencyFormatting(leadDetail?.accessories_price || 0):' NA'
        ].filter(Boolean).join(', ');  
        return accessoriesInfo || 'NA';
    }
      useEffect(() => {
        const labels = ['Zoom In', 'Zoom Out', 'Rotate', 'Invert', 'Fill Screen'];

        const applyTitles = () => {
    
        const outer = document.querySelector('.verfication-img-outer');
        if (!outer) return false;

        const btnContainer = outer.querySelector<HTMLElement>(
            'div[style*="position: absolute"][style*="right: 10px"]'
        );
        if (!btnContainer) return false;

        const icons = btnContainer.querySelectorAll<HTMLElement>(':scope > div');

        if (icons.length !== labels.length) return false;

        icons.forEach((icon, index) => {
            if (!icon.hasAttribute('title')) {
            icon.setAttribute('title', labels[index]);
            icon.setAttribute('aria-label', labels[index]);
            icon.setAttribute('role', 'button');
            }
        });

        return true;
        };

        if (applyTitles()) return;

        const observer = new MutationObserver(() => {
        if (applyTitles()) {
            observer.disconnect();
        }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, [activeImage]);


    return (
        <React.Fragment>
        <FullPageLoader show={loading} />
        <div className='lead-list-outer container-fluid main-outer'>
            <div className=''>
                <div className="top-heading  top-heading-btn">
                    {/* {translations.Insurance?.INSURANCE_DETAIL?.['POLICY_NO'] || translations.commonMsg?.loading} */}
                    <h1>{leadDetail?.customer_name}: {leadDetail?.insurance_id} 
                        <i className='ic-content_copy m-sm-l' 
                            onClick={() => HELPER.handleCopyText(leadDetail?.insurance_id)} style={{ cursor: 'pointer' }}>
                        </i>
                    </h1>
                </div>
                <h3 className='top-mg'>{translations?.commonMsg?.['status'] || translations.commonMsg?.loading} : {status_name}</h3>
                { leadDetail?.order_id && <h3 >{translations.Insurance?.INSURANCE_DETAIL?.['ORDER_ID'] || translations.commonMsg?.loading} : {leadDetail?.order_id || ""} </h3>}
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='payment-proof-outer'>
                            <h2>{translations.Insurance?.INSURANCE_DETAIL?.['UPLOADED_DOCUMENTS'] || translations.commonMsg?.loading}</h2>
                         
                            <div className='verfication-img-outer'>
                            <span className='active-img-name'>{activeImage?.name}</span>
                               
                            {
                                activeImage && activeImage.path ?
                                <div className='verfication-img' onTouchMove={(event) => {
                                    let fileType = activeImage.path.split('.')
                                    fileType = fileType[fileType.length - 1]

                                    let isTouchEvntActive = fileType === 'jpeg' || fileType === 'jpg' || fileType === 'png' ? true : false

                                    if (isTouchEvntActive) {
                                        event.preventDefault();
                                    }
                                }}
                                >

                                    <div className="carousel image-varification-slider">
                                        <ul className="carousel__slides">

                                            <li className="carousel__slide carousel__slide--active">
                                                <div className="carousel-slideimg pfd-img-height">
                                                    {
                                                        activeDocExtension !== 'image' ?
                                                            <a href={activeImage.path} target="_blank" rel="noreferrer"><i className={`ic-${activeDocExtension}-file pdf-icons-normal-gallery`}></i></a>

                                                            :
                                                            activeImageIndex >= 0 &&
                                                            <ReactPanZoom
                                                                image={activeImage?.path}
                                                                alt="Image alt text"
                                                            />
                                                    }

                                                </div>
                                            </li>

                                        </ul>

                                        <div className="image-opt">
                                            <ul>

                                                {/* if previous image exists */}
                                                {(sliderImages[activeImageIndex - 1])
                                                    ?
                                                    <li className="icn-pre-slide" onClick={() => handleImageChange('previous')}>
                                                        <i className="ic-keyboard_arrow_left a-class"></i>
                                                    </li>
                                                    : ""
                                                }
                                               {sliderImages.length > 1 && (
                                                    <li className="icn-next-slide" onClick={() => handleImageChange('next')}>
                                                        <i className="ic-keyboard_arrow_right a-class"></i>
                                                    </li>
                                                )}


                                            </ul>
                                        </div>
                                    </div>
                                    {
                                    
                                        SHOW_ACTION_DOC_STATUS.includes(leadDetail?.action_status) && (
                                            activeImage?.doc_status === 1 ? (
                                                <div className="btn-save-remarks btn-re-upload" onClick={() => ShowRejectModel('re_submit', activeImage?.document_id)}>
                                                    <button className="btn-line">{translations.Insurance?.INSURANCE_DETAIL?.['REQUEST_FOR_REUPLOAD'] || translations.commonMsg?.loading}</button>
                                                </div>
                                            ) : activeImage?.doc_status === 2 ? (
                                                <div className="btn-save-remarks btn-re-upload">
                                                    <button className="btn-line" disabled>{translations.Insurance?.INSURANCE_DETAIL?.['REQUESTED_FOR_REUPLOAD'] || translations.commonMsg?.loading}</button>
                                                </div>
                                            ) : null
                                        )
                                    }
                                </div>
                                
                                :
                                null
                            } 
                            </div>
                        </div>
                    </div>
                   <div className="col-md-6">
                    <div className="accordion-outer lead-detail-accordion-outer">
                        <Accordion defaultActiveKey="0" alwaysOpen>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header> {translations.Insurance?.INSURANCE_DETAIL?.['PERSONAL_DETAILS'] || translations.commonMsg?.loading}</Accordion.Header>
                            <Accordion.Body>
                                <div className="lead-detail-container">
                                    <ul className="info-list">
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['NAME'] || translations.commonMsg?.loading} </span>
                                            <span className="value">{leadDetail?.customer?.name || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['INSURED_ADDRESS'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.customer?.address || ""}</span>
                                        </li>
                                    </ul>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        </Accordion>
                         <Accordion >
                        <Accordion.Item eventKey="1">
                            <Accordion.Header> {translations.Insurance?.INSURANCE_DETAIL?.['VEHICLE_DETAILS'] || translations.commonMsg?.loading}</Accordion.Header>
                            <Accordion.Body>
                            <div className="lead-detail-container">
                                    <ul className="info-list">
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['BRAND'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.make_name || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['MODEL'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.model_name + ' ' + leadDetail?.lead_vehicle?.version_name || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['LICENSE_NUMBER'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.plate_no || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['MACHINE_NUMBER'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.machine_number || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['CHASSIS_NUMBER'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.chassis_number || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['FUNCTION'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{
                                            leadDetail?.lead_vehicle?.vehicle_condition_id === 1 ? 'NEW':'USED' 
                                            }</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['SEAT_CAPACITY'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.seat_capacity || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['YEAR_OF_MANUFACTURING'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.mfg_year || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['COLORS'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.color || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['LOCATION'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{leadDetail?.lead_vehicle?.plate_area || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['ADDITIONAL_MODIFICATION_DETAILS'] || translations.commonMsg?.loading}</span>
                                            <span className="value">
                                                Accessories information - 
                                                {getAdditionalInfo(leadDetail)}
                                            </span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['EXISTING_CONDITION_DETAILS'] || translations.commonMsg?.loading}</span>
                                            <span className="value">{ leadDetail?.lead_vehicle?.vehicle_condition_detail|| "-"}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['TOTAL_SUM_INSURED'] || translations.commonMsg?.loading} </span>
                                            <span className="value">{HELPER.addCurrencyFormatting(leadDetail?.total_fmv_car) || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['COVERAGE_TYPE'] || translations.commonMsg?.loading} </span>
                                            <span className="value">{leadDetail?.insurance_type || ""}</span>
                                        </li>
                                    </ul>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        </Accordion>
                         <Accordion>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>{translations.Insurance?.INSURANCE_DETAIL?.['INSURANCE_DETAILS'] || translations.commonMsg?.loading}</Accordion.Header>
                            <Accordion.Body>
                                <div className="lead-detail-container">
                                    <ul className="info-list">
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['CONTRACT_NO'] || translations.commonMsg?.loading} </span>
                                            <span className="value">{leadDetail?.insurance_id || ""}</span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['START_DATE'] || translations.commonMsg?.loading} </span>
                                            <span className="value">{
                                                leadDetail?.insurance_starting_date
                                                &&
                                                dateFormat(leadDetail?.insurance_starting_date, 'd mmm yyyy')
                                                }
                                            </span>
                                        </li>
                                        <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['END_DATE'] || translations.commonMsg?.loading} </span>
                                            <span className="value">{
                                                leadDetail?.insurance_ending_date
                                                &&
                                                dateFormat(leadDetail.insurance_ending_date, 'd mmm yyyy') 
                                                }
                                                </span>
                                        </li>
                                         <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['DISCOUNT'] || translations.commonMsg?.loading} </span>
                                            <span className="value">
                                                {
                                                    leadDetail?.customer_discount_per
                                                        &&
                                                    leadDetail?.customer_discount_per + '%'
                                                }
                                            </span>
                                        </li>
                                         <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['STAMP_DUTY_AMOUNT'] || translations.commonMsg?.loading} </span>
                                            <span className="value">Rp 10.000</span>
                                        </li>
                                         <li>
                                            <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['POLICY_FEE'] || translations.commonMsg?.loading} </span>
                                            <span className="value">Rp 20.000</span>
                                        </li>
                                    </ul>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        </Accordion>
                        {   
                            leadDetail?.lead_addon && leadDetail?.lead_addon.length > 0
                            &&
                            <Accordion >
                            <Accordion.Item eventKey="3">
                                <Accordion.Header> {translations.Insurance?.INSURANCE_DETAIL?.['ADD_ON_DETAILS'] || translations.commonMsg?.loading}</Accordion.Header>
                                <Accordion.Body>
                                <div className="lead-detail-container" >
                                    <ul className="info-list">
                                        {
                                            LEAD_ADDON &&
                                            LEAD_ADDON.map((item: any, index: number) => {
                                                const addonDetail: any = getAddonValue(item, item.type);

                                                // Only render <li> if addonValue is not false
                                                if (Object.keys(addonDetail).length) {
                                                    return (
                                                        <li key={index}>
                                                        <span className="label">{addonDetail.label || ""}</span>
                                                        <span className="value">{addonDetail.value || 0}</span>
                                                        </li>
                                                    );
                                                }

                                                // If addonValue is false, don't render anything
                                                return null;
                                            })
                                        }
                                        
                                    </ul>
                                </div>
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                        }
                        {
                            leadDetail?.policy_no && leadDetail?.policy_no != null 
                            &&
                            <div className="lead-detail-container">
                                <ul className=".info-list policy-outer">
                                    <li>
                                        <span className="label">{translations.Insurance?.INSURANCE_DETAIL?.['POLICY_NUMBER'] || translations.commonMsg?.loading} </span>
                                        <span className="value">{leadDetail?.policy_no}</span>
                                    </li>
                                </ul>
                            </div>
                        }

                        { 
                            (SHOW_ACTION_STATUS.includes(leadDetail?.action_status)) 
                                &&
                            !leadDetail?.reuploadStatus
                                &&
                            <div className='btn-save-remarks btn-approve-reject'>
                                <button className='btn-primary m-sm-r' onClick={() => ShowRejectModel('approve')}>{translations.commonMsg?.['Approve'] || translations.commonMsg?.loading}</button>
                                <button className='btn-line' onClick={() => ShowRejectModel('reject')}>{translations.commonMsg?.['reject'] || translations.commonMsg?.loading}</button>
                            </div>
                        }
                    </div>
                   </div>
                </div>

            </div>
            {modalVisible === 'reject' && (
                 <ConfirmPopUp
                    confirmNo={confirmNo}
                    confirmYes={confirmYes}
                    isReasonVisible={true}
                    reasonList = {reasonList}
                    handleChange={handleReasonChange}
                    selectedReason={selectedReason}
                    placeholder={translations.Insurance?.INSURANCE_DETAIL?.['SELECT_REASON'] || translations.commonMsg?.loading}
                    isConfirmNotVisible={true}
                    popoupError={popoupError}
                    message={translations.Insurance?.INSURANCE_DETAIL?.['LEAD_REJECT_MESSAGE'] || translations.commonMsg?.loading} />
                    // message="Are you sure you want to reject this insurance lead?" />
            )}

            {modalVisible === "approve" && (
                <ConfirmPopUp
                    confirmNo={confirmNo}
                    confirmYes={confirmYes}
                    isConfirmNotVisible={true}
                    // message="Are you sure you want to approve this insurance lead?"
                    message={translations.Insurance?.INSURANCE_DETAIL?.['LEAD_APPROVE_MESSAGE'] || translations.commonMsg?.loading}
                />
            )}

            {modalVisible === "re_submit" && (
                <ConfirmPopUp
                    confirmNo={confirmNo}
                    confirmYes={confirmYes}
                    allowComment={true}
                    popoupError={popoupError}
                    handleChange={handleReasonChange}
                    isConfirmNotVisible={true}
                    is_reupload={true}
                    // message="Are you sure you want to Request for Re-submittion?"
                    message={translations.Insurance?.INSURANCE_DETAIL?.['LEAD_RE_SUBMIT_MESSAGE'] || translations.commonMsg?.loading}
                />
            )}
        </div>
        </React.Fragment>
    )  
}

export default LeadDetail;